import { TestLocators } from 'constants/Locators';

import { MUI } from 'ci-esi-web-shared';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectSpEstimate } from 'app/components/containers/layout/ConfigTabs/EconomicsControl/WellDesignCapex/selectors';
import { formatByLocale } from 'helpers/formatters';
import { translations } from 'locales/i18n';

export function SpEstimateData() {
  const { t } = useTranslation();
  const spEstimate = formatByLocale(Math.round(Number(useSelector(selectSpEstimate))));
  const label = translations.CONFIG_PANEL.ECONOMICS.CONTROL.WELL_DESIGN_AND_CAPEX.SP_ESTIMATE.TITLE;

  return (
    <MUI.InputLabel
      sx={{ marginTop: '-12px', fontSize: '8px', lineHeight: '39px' }}
      data-testid={TestLocators.WellDesignCapex_SpEstimate_SpEstimateData}
    >
      {t(label)}
      {` $${spEstimate}`}
    </MUI.InputLabel>
  );
}
